export default __webpack_public_path__ + "static/media/Ballroll_00165.d015759a.png";